/* ===== PEEKORALAB THEME JS ===== */
(function(){
'use strict';

/* ─── Currency & Market ─── */
var CURRENCY = 'CAD';
var MARKET = 'CA';

/* ─── Language / i18n ─── */
var LANG = 'EN';
var I18N = {
  EN: {
    nav_home:'Home', nav_shop:'Shop', nav_about:'About', nav_faq:'FAQ', nav_contact:'Contact',
    shopNow:'Shop Now', viewCart:'View Cart',
    addToCart:'Add to Cart', buyNow:'Buy Now — Checkout Instantly',
    subscribe:'Subscribe', subscribing:'Subscribing…', subscribed:'Subscribed!',
    emailPlaceholder:'Enter your email',
    emailHeading:'Get 10% Off Your First Order',
    emailSub:'Plus early access to new products, parenting tips, and exclusive member deals. For families in Canada & US.',
    emailNote:'No spam, ever. Unsubscribe anytime. Your privacy is safe with us.',
    freeShippingBanner:'Free shipping to Canada, the USA & Australia',
    sending:'Sending…',
    footerShop:'Shop', footerHelp:'Help', footerCompany:'Company',
    allProducts:'All Products', giftIdeas:'Gift Ideas',
    faq:'FAQ', contactUs:'Contact Us', shippingInfo:'Shipping Info',
    returnsRefunds:'Returns & Refunds', privacyPolicy:'Privacy Policy',
    ourStory:'Our Story', ourMission:'Our Mission',
  },
  FR: {
    nav_home:'Accueil', nav_shop:'Boutique', nav_about:'À propos', nav_faq:'FAQ', nav_contact:'Contact',
    shopNow:'Magasiner', viewCart:'Voir le panier',
    addToCart:'Ajouter au panier', buyNow:'Acheter maintenant',
    subscribe:'S’abonner', subscribing:'Abonnement…', subscribed:'Abonné !',
    emailPlaceholder:'Votre adresse courriel',
    emailHeading:'Obtenez 10 % sur votre 1re commande',
    emailSub:'Accès anticipé aux nouveaux produits et offres exclusives pour les familles au Canada et aux É.-U.',
    emailNote:'Pas de spam. Désabonnez-vous en tout temps.',
    freeShippingBanner:'Livraison gratuite dès 50 $ CA / 38 $ US',
    sending:'Envoi…',
    footerShop:'Boutique', footerHelp:'Aide', footerCompany:'Entreprise',
    allProducts:'Tous les produits', giftIdeas:'Idées cadeaux',
    faq:'FAQ', contactUs:'Nous joindre', shippingInfo:'Livraison',
    returnsRefunds:'Retours et remboursements', privacyPolicy:'Politique de confidentialité',
    ourStory:'Notre histoire', ourMission:'Notre mission',
  }
};

function setLanguage(lang) {
  LANG = lang;
  try { localStorage.setItem('pk_lang', lang); } catch(e) {}
  document.querySelectorAll('.lang-btn').forEach(function(btn){
    var active = btn.dataset.lang === lang;
    btn.classList.toggle('active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  document.documentElement.lang = lang === 'FR' ? 'fr' : 'en';
  var t = I18N[lang] || I18N.EN;
  document.querySelectorAll('[data-i18n]').forEach(function(el){
    var key = el.dataset.i18n;
    if (!t[key]) return;
    if (el.tagName === 'INPUT') { el.placeholder = t[key]; }
    else { el.textContent = t[key]; }
  });
}

function switchCurrency(cur) {
  CURRENCY = cur;
  try { localStorage.setItem('pk_currency', cur); } catch(e) {}
  document.querySelectorAll('.currency-opt').forEach(function(el){
    var active = el.dataset.cur === cur;
    el.classList.toggle('active', active);
    el.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  document.querySelectorAll('.pc-price, .product-price').forEach(function(el){
    var cad = el.dataset.cad, usd = el.dataset.usd;
    if (!cad) return;
    var price = cur === 'USD'
      ? parseFloat(usd && usd !== cad ? usd : cad).toFixed(2)
      : parseFloat(cad).toFixed(2);
    el.innerHTML = '$' + price + ' <small class="price-currency-label">' + cur + '</small>';
    el.dataset.activeCurrency = cur;
  });
  document.querySelectorAll('.hc-price[data-cad]').forEach(function(el){
    var cad = el.dataset.cad, usd = el.dataset.usd;
    if (!cad) return;
    var price = cur === 'USD'
      ? parseFloat(usd && usd !== cad ? usd : cad).toFixed(2)
      : parseFloat(cad).toFixed(2);
    el.textContent = '$' + price + ' ' + cur;
  });
  updateCartSummary();
}

function setMarket(code) {
  MARKET = code;
  try { localStorage.setItem('pk_market', code); } catch(e) {}
  document.querySelectorAll('.market-flag-btn').forEach(function(btn){
    btn.classList.toggle('active', btn.dataset.market === code);
  });
  switchCurrency(code === 'US' ? 'USD' : 'CAD');
}

/* ─── Navbar scroll ─── */
function initNavbar() {
  var nav = document.getElementById('navbar');
  if (!nav) return;
  function check() {
    nav.classList.toggle('scrolled', window.scrollY > 40);
  }
  window.addEventListener('scroll', check, {passive:true});
  check();
}

/* ─── Mobile menu ─── */
function initMobileMenu() {
  var btn = document.getElementById('nav-hamburger');
  var menu = document.getElementById('mobile-menu');
  var close = document.getElementById('mobile-close');
  if (!btn || !menu) return;
  btn.addEventListener('click', function(){ menu.classList.toggle('open'); });
  if (close) close.addEventListener('click', function(){ menu.classList.remove('open'); });
  menu.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', function(){ menu.classList.remove('open'); });
  });
}

/* ─── Countdown ─── */
function initCountdown() {
  var el = document.getElementById('countdown');
  if (!el) return;
  var endAttr = el.getAttribute('data-end');
  var end = endAttr ? new Date(endAttr.replace(' ', 'T')).getTime() : NaN;
  if (!end || isNaN(end) || end <= Date.now()) { el.style.display = 'none'; return; }
  function pad(n){ return n<10?'0'+n:n; }
  function tick() {
    var diff = Math.max(0, end - Date.now());
    var d = Math.floor(diff/86400000);
    var h = Math.floor((diff%86400000)/3600000);
    var m = Math.floor((diff%3600000)/60000);
    var s = Math.floor((diff%60000)/1000);
    el.textContent = (d>0 ? d+'d ' : '') + pad(h)+':'+pad(m)+':'+pad(s);
    if (diff > 0) setTimeout(tick, 1000); else el.style.display = 'none';
  }
  tick();
}

/* ─── Ticker hover pause ─── */
function initTicker() {
  var track = document.querySelector('.ticker-track');
  if (!track) return;
  track.addEventListener('mouseenter', function(){ track.style.animationPlayState='paused'; });
  track.addEventListener('mouseleave', function(){ track.style.animationPlayState='running'; });
}

/* ─── Sticky bar ─── */
function initStickyBar() {
  var bar = document.getElementById('sticky-bar');
  if (!bar) return;
  var shown = false;
  window.addEventListener('scroll', function(){
    var should = window.scrollY > 500;
    if (should !== shown) {
      bar.classList.toggle('visible', should);
      shown = should;
    }
  }, {passive:true});
}

/* ─── Exit popup ─── */
function initExitPopup() {
  var popup = document.getElementById('exit-popup');
  if (!popup) return;
  var shown = false;
  var dismissed = sessionStorage.getItem('pk_popup_dismissed');
  if (dismissed) return;
  document.addEventListener('mouseleave', function(e){
    if (e.clientY <= 0 && !shown) {
      shown = true;
      popup.classList.add('show');
    }
  });
}

function closePopup() {
  var popup = document.getElementById('exit-popup');
  if (popup) popup.classList.remove('show');
  sessionStorage.setItem('pk_popup_dismissed','1');
}
window.closePopup = closePopup;

/* ─── Scroll animations ─── */
function initScrollAnimations() {
  var els = document.querySelectorAll('.fade-up');
  if (!els.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        io.unobserve(e.target);
      }
    });
  }, {threshold:.15});
  els.forEach(function(el){ io.observe(el); });
}

/* ─── Cart state ─── */
var cartData = { items:[], total:0 };

function fetchCart() {
  return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(data){
    cartData = data;
    updateCartBadge(data.item_count || 0);
    return data;
  }).catch(function(){ return cartData; });
}

function updateCartBadge(count) {
  document.querySelectorAll('.cart-badge').forEach(function(el){
    el.textContent = count;
    el.dataset.count = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

/* ─── Add to cart ─── */
function addToCart(variantId, qty, btn, imgSrc, name) {
  qty = qty || 1;
  if (btn) {
    btn.classList.add('loading');
    btn.dataset.origText = btn.innerHTML;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px;animation:spin .8s linear infinite"><circle cx="12" cy="12" r="10" stroke-opacity=".25"/><path d="M12 2a10 10 0 0 1 10 10"/></svg> Adding...';
  }
  return fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body: JSON.stringify({id: variantId, quantity: qty})
  })
  .then(function(r){ return r.json(); })
  .then(function(item){
    if (item.status && item.status !== 200) throw new Error(item.description || 'Error');
    return fetchCart().then(function(){
      if (btn) {
        btn.classList.remove('loading');
        btn.classList.add('added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px"><polyline points="20 6 9 17 4 12"/></svg> Added!';
        setTimeout(function(){
          btn.classList.remove('added');
          if (btn.dataset.origText) btn.innerHTML = btn.dataset.origText;
        }, 2200);
      }
      renderCartDrawer(cartData);
      openCartDrawer();
      return item;
    });
  })
  .catch(function(err){
    if (btn) {
      btn.classList.remove('loading');
      if (btn.dataset.origText) btn.innerHTML = btn.dataset.origText;
    }
    console.error('Cart error:', err);
  });
}
window.addToCart = addToCart;

/* ─── Cart notification ─── */
function showCartNotification(item, imgSrc, name) {
  var n = document.getElementById('cart-notification');
  if (!n) return;
  var img = n.querySelector('img');
  var title = n.querySelector('.cn-title');
  var sub = n.querySelector('.cn-sub');
  if (img && imgSrc) img.src = imgSrc;
  if (title) title.textContent = (name || item.title) + ' added!';
  if (sub) sub.textContent = 'View your cart to checkout';
  n.classList.add('show');
  setTimeout(function(){ n.classList.remove('show'); }, 3200);
}

/* ─── Cart page ─── */
function initCartPage() {
  var cartItemsEl = document.getElementById('cart-items');
  var cartTotalEl = document.getElementById('cart-total');
  var cartCountEl = document.getElementById('cart-count');
  var cartEmptyEl = document.getElementById('cart-empty');
  var cartFilledEl = document.getElementById('cart-filled');
  if (!cartItemsEl) return;

  function renderCart(data) {
    var items = data.items || [];
    if (cartCountEl) cartCountEl.textContent = data.item_count || 0;
    if (cartEmptyEl) cartEmptyEl.style.display = items.length ? 'none' : 'block';
    if (cartFilledEl) cartFilledEl.style.display = items.length ? 'grid' : 'none';
    cartItemsEl.innerHTML = '';
    items.forEach(function(item){
      var price = (item.final_line_price/100).toFixed(2);
      var unitPrice = (item.final_price/100).toFixed(2);
      var div = document.createElement('div');
      div.className = 'cart-item';
      div.dataset.key = item.key;
      div.innerHTML =
        '<div class="cart-item-img"><img src="'+(item.image||'')+'?width=200" alt="'+item.title+'" loading="lazy"></div>'+
        '<div>'+
          '<div class="cart-item-name">'+item.product_title+'</div>'+
          '<div class="cart-item-variant">'+item.variant_title+'</div>'+
          '<div class="qty-controls">'+
            '<button class="qty-control-btn" data-action="decrease" data-key="'+item.key+'" aria-label="Decrease quantity">−</button>'+
            '<span class="qty-display">'+item.quantity+'</span>'+
            '<button class="qty-control-btn" data-action="increase" data-key="'+item.key+'" aria-label="Increase quantity">+</button>'+
          '</div>'+
          '<button class="cart-remove" data-key="'+item.key+'">Remove</button>'+
        '</div>'+
        '<div class="cart-item-price">$'+price+'<br><small style="font-weight:600;font-size:13px;color:#6B6154">$'+unitPrice+' each</small></div>';
      cartItemsEl.appendChild(div);
    });
    updateCartSummary(data);
  }

  function updateQty(key, qty) {
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){return r.json();}).then(function(data){
      cartData = data;
      renderCart(data);
      updateCartBadge(data.item_count||0);
    });
  }

  cartItemsEl.addEventListener('click', function(e){
    var btn = e.target.closest('[data-action]');
    var rem = e.target.closest('.cart-remove');
    if (btn) {
      var key = btn.dataset.key;
      var item = (cartData.items||[]).find(function(i){return i.key===key;});
      if (!item) return;
      var newQty = btn.dataset.action==='increase' ? item.quantity+1 : Math.max(0, item.quantity-1);
      updateQty(key, newQty);
    }
    if (rem) {
      updateQty(rem.dataset.key, 0);
    }
  });

  fetchCart().then(renderCart);
}

function updateCartSummary(data) {
  data = data || cartData;
  var subtotalEl = document.getElementById('cart-subtotal');
  var totalEl = document.getElementById('cart-total');
  if (!data || !data.total_price) return;
  var total = (data.total_price/100).toFixed(2);
  if (subtotalEl) subtotalEl.textContent = '$'+total;
  if (totalEl) totalEl.textContent = '$'+total;
}

/* ─── Product page ─── */
function initProductPage() {
  var addBtn = document.getElementById('add-to-cart-btn');
  var buyBtn = document.getElementById('buy-now-btn');
  var variantInput = document.getElementById('selected-variant');
  var qtyInput = document.getElementById('qty');
  var mainImg = document.getElementById('product-main-image');
  if (!addBtn || !variantInput) return;

  var variants = window.PK_VARIANTS || [];
  var optionNames = window.PK_OPTIONS || [];
  var selectedOptions = {};

  /* map option index → current value, seeded from active buttons */
  optionNames.forEach(function(name, idx) {
    var handle = name.toLowerCase().replace(/\s+/g, '-');
    var btn = document.querySelector('[data-group="' + handle + '"].active');
    if (btn) selectedOptions[idx] = btn.dataset.value;
  });

  function resolveVariant() {
    if (!variants.length) return null;
    var values = optionNames.map(function(_, i) { return selectedOptions[i]; });
    /* exact match */
    var v = variants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === values[i]; });
    });
    return v || variants[0];
  }

  function applyVariant(v) {
    if (!v) return;
    variantInput.value = v.id;
    /* price */
    var priceEl = document.getElementById('product-price-display');
    if (priceEl) {
      var cad = (v.price / 100).toFixed(2);
      priceEl.dataset.cad = cad;
      priceEl.innerHTML = '$' + cad + ' <small class="price-currency-label">CAD</small>';
    }
    /* availability */
    if (v.available) {
      addBtn.disabled = false;
      addBtn.classList.remove('sold-out');
      addBtn.innerHTML = addBtn.dataset.origHtml || addBtn.innerHTML;
    } else {
      addBtn.disabled = true;
      addBtn.classList.add('sold-out');
      if (!addBtn.dataset.origHtml) addBtn.dataset.origHtml = addBtn.innerHTML;
      addBtn.innerHTML = 'Sold Out';
    }
    /* image */
    if (v.featured_image && mainImg) {
      var imgUrl = v.featured_image.src || '';
      if (imgUrl) {
        mainImg.src = imgUrl.replace(/(\.\w{3,4})(\?|$)/, '_800x$1$2');
        document.querySelectorAll('.product-thumb').forEach(function(t) {
          t.classList.toggle('active', t.dataset.image && t.dataset.image.includes(v.featured_image.src.split('?')[0].split('/').pop().split('.')[0]));
        });
      }
    }
  }

  /* wire option buttons */
  document.querySelectorAll('.variant-btn, .color-swatch').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = this.dataset.group || 'option1';
      document.querySelectorAll('[data-group="' + group + '"]').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      var idx = optionNames.findIndex(function(n) { return n.toLowerCase().replace(/\s+/g, '-') === group; });
      if (idx >= 0) selectedOptions[idx] = this.dataset.value;
      applyVariant(resolveVariant());
    });
  });

  /* seed initial state */
  applyVariant(resolveVariant());

  var productName = document.querySelector('.product-title') ? document.querySelector('.product-title').textContent.trim() : '';

  addBtn.addEventListener('click', function() {
    if (this.disabled) return;
    var vid = parseInt(variantInput.value);
    var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    if (!vid) return;
    addToCart(vid, qty, addBtn, mainImg ? mainImg.src : '', productName);
  });

  if (buyBtn) {
    buyBtn.addEventListener('click', function() {
      var vid = parseInt(variantInput.value);
      if (!vid) return;
      addToCart(vid, 1, null, null, null).then(function() { window.location.href = '/checkout'; });
    });
  }

  /* thumbnails */
  document.querySelectorAll('.product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (mainImg && this.dataset.image) mainImg.src = this.dataset.image;
      document.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* qty stepper */
  var qtyInc = document.getElementById('qty-inc');
  var qtyDec = document.getElementById('qty-dec');
  if (qtyInc && qtyInput) qtyInc.addEventListener('click', function() { qtyInput.value = Math.min(10, parseInt(qtyInput.value) + 1); });
  if (qtyDec && qtyInput) qtyDec.addEventListener('click', function() { qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1); });

  /* tabs */
  var tabs = document.querySelectorAll('.tab-btn');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
      document.querySelectorAll('.tab-pane').forEach(function(p) { p.classList.remove('active'); });
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
      var target = document.getElementById('tab-' + this.dataset.tab);
      if (target) target.classList.add('active');
    });
  });
}

/* ─── Sticky bar add-to-cart ─── */
function initStickyCart() {
  var stickyBtn = document.getElementById('sticky-add-btn');
  if (!stickyBtn) return;
  stickyBtn.addEventListener('click', function(){
    var addBtn = document.getElementById('add-to-cart-btn');
    if (addBtn) { addBtn.click(); addBtn.scrollIntoView({behavior:'smooth',block:'center'}); }
  });
}

/* ─── FAQ accordion ─── */
function initFAQ() {
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i){ i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
  document.querySelectorAll('.faq-cat-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.faq-cat-btn').forEach(function(b){ b.classList.remove('active'); });
      this.classList.add('active');
      var cat = this.dataset.cat;
      document.querySelectorAll('.faq-item').forEach(function(item){
        item.style.display = (cat==='all'||!cat||item.dataset.cat===cat) ? '' : 'none';
      });
    });
  });
}

/* ─── Shop filter ─── */
function initShopFilter() {
  document.querySelectorAll('.filter-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.filter-btn').forEach(function(b){ b.classList.remove('active'); });
      this.classList.add('active');
      var filter = this.dataset.filter;
      document.querySelectorAll('.product-card').forEach(function(card){
        card.style.display = (filter==='all'||!filter||card.dataset.category===filter) ? '' : 'none';
      });
    });
  });
}

/* ─── Cart Drawer ─── */
function openCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  if (!drawer) return;
  fetchCart().then(function(data) { renderCartDrawer(data); });
  drawer.classList.add('open');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}
window.openCartDrawer = openCartDrawer;

function closeCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  if (drawer) drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}
window.closeCartDrawer = closeCartDrawer;

function renderCartDrawer(data) {
  data = data || cartData;
  var items = data.items || [];
  var emptyEl = document.getElementById('cart-drawer-empty');
  var itemsEl = document.getElementById('cart-drawer-items');
  var footerEl = document.getElementById('cart-drawer-footer');
  var totalEl = document.getElementById('cart-drawer-total');
  var countEl = document.querySelector('.cd-count');
  if (!itemsEl) return;
  if (countEl) countEl.textContent = '(' + (data.item_count || 0) + ')';
  if (emptyEl) emptyEl.style.display = items.length ? 'none' : 'flex';
  if (footerEl) footerEl.style.display = items.length ? 'block' : 'none';
  if (totalEl) totalEl.textContent = '$' + ((data.total_price || 0) / 100).toFixed(2);
  itemsEl.innerHTML = items.map(function(item) {
    var img = (item.image || '').replace(/(\.\w{3,4})(\?|$)/, '_100x100$1$2');
    var linePrice = '$' + (item.final_line_price / 100).toFixed(2);
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cd-item-variant">' + item.variant_title + '</div>' : '';
    return '<div class="cd-item">' +
      '<img class="cd-item-img" src="' + img + '" alt="' + item.title + '" loading="lazy">' +
      '<div class="cd-item-details">' +
        '<div class="cd-item-name">' + item.product_title + '</div>' +
        variantLine +
        '<div class="cd-qty">' +
          '<button class="cd-qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease">−</button>' +
          '<span class="cd-qty-val">' + item.quantity + '</span>' +
          '<button class="cd-qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase">+</button>' +
        '</div>' +
        '<button class="cd-remove" data-key="' + item.key + '" aria-label="Remove">Remove</button>' +
      '</div>' +
      '<div class="cd-item-price">' + linePrice + '</div>' +
    '</div>';
  }).join('');
}

function initCartDrawer() {
  var closeBtn = document.getElementById('cart-drawer-close');
  var overlay = document.getElementById('cart-drawer-overlay');
  var itemsEl = document.getElementById('cart-drawer-items');
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  /* cart icon opens drawer */
  document.querySelectorAll('.nav-cart').forEach(function(link) {
    link.addEventListener('click', function(e) { e.preventDefault(); openCartDrawer(); });
  });

  /* notification "View Cart" opens drawer */
  var notifView = document.getElementById('cart-notification-view');
  if (notifView) {
    notifView.addEventListener('click', function(e) {
      e.preventDefault();
      var n = document.getElementById('cart-notification');
      if (n) n.classList.remove('show');
      openCartDrawer();
    });
  }

  /* delegated qty/remove inside drawer */
  if (itemsEl) {
    itemsEl.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action]');
      var rem = e.target.closest('.cd-remove');
      function updateAndRender(key, qty) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function(r) { return r.json(); }).then(function(data) {
          cartData = data;
          updateCartBadge(data.item_count || 0);
          renderCartDrawer(data);
        });
      }
      if (btn) {
        var key = btn.dataset.key;
        var item = (cartData.items || []).find(function(i) { return i.key === key; });
        if (!item) return;
        updateAndRender(key, btn.dataset.action === 'increase' ? item.quantity + 1 : Math.max(0, item.quantity - 1));
      }
      if (rem) updateAndRender(rem.dataset.key, 0);
    });
  }

  /* close on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.classList.contains('open')) closeCartDrawer();
    }
  });
}

/* ─── Predictive Search ─── */
function initSearch() {
  var btn = document.getElementById('nav-search-btn');
  var overlay = document.getElementById('search-overlay');
  var input = document.getElementById('search-input');
  var closeBtn = document.getElementById('search-close');
  var backdrop = document.getElementById('search-backdrop');
  var resultsEl = document.getElementById('search-results');
  if (!btn || !overlay) return;
  var timer = null;

  function openSearch() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    btn.setAttribute('aria-expanded', 'true');
    setTimeout(function() { if (input) input.focus(); }, 80);
  }
  function closeSearch() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    btn.setAttribute('aria-expanded', 'false');
    if (input) input.value = '';
    if (resultsEl) resultsEl.innerHTML = '';
  }

  btn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) closeSearch();
  });

  if (input) {
    input.addEventListener('input', function() {
      clearTimeout(timer);
      var q = this.value.trim();
      if (!q || q.length < 2) { if (resultsEl) resultsEl.innerHTML = ''; return; }
      timer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            products = products.filter(function(p) {
              return !/official-bundle/i.test(p.url || '');
            });
            if (!resultsEl) return;
            if (!products.length) {
              resultsEl.innerHTML = '<div class="search-no-results">No products found for "' + q + '"</div>';
              return;
            }
            resultsEl.innerHTML = products.map(function(p) {
              var img = p.image ? p.image.replace(/(\.\w{3,4})(\?|$)/, '_100x100$1$2') : '';
              var price = p.price ? '$' + (parseInt(p.price) / 100).toFixed(2) + ' CAD' : '';
              return '<a href="' + p.url + '" class="search-result-item" role="option">' +
                (img ? '<img src="' + img + '" alt="' + p.title + '" width="48" height="48" loading="lazy">' : '<div class="search-result-placeholder"></div>') +
                '<div class="search-result-info">' +
                  '<div class="search-result-title">' + p.title + '</div>' +
                  (price ? '<div class="search-result-price">' + price + '</div>' : '') +
                '</div>' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;flex-shrink:0;opacity:.35" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>' +
              '</a>';
            }).join('') +
            '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-view-all">View all results for "' + q + '" →</a>';
          });
      }, 260);
    });
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && this.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(this.value.trim()) + '&type=product';
      }
    });
  }
}

/* ─── Email form ─── */
function handleEmailSubmit(event) {
  event.preventDefault();
  var form = event.target;
  var email = form.querySelector('input[type="email"]').value;
  var btn = form.querySelector('button[type="submit"]');
  if (!email) return;
  btn.textContent = 'Subscribing...';
  btn.disabled = true;
  setTimeout(function(){
    btn.textContent = 'Subscribed!';
    form.querySelector('input[type="email"]').value = '';
    setTimeout(function(){ btn.textContent = 'Subscribe'; btn.disabled = false; }, 2500);
  }, 900);
}
window.handleEmailSubmit = handleEmailSubmit;

/* ─── Contact form ─── */
function initContactForm() {
  var form = document.getElementById('contact-form');
  if (!form) return;
  form.addEventListener('submit', function(e){
    var btn = form.querySelector('.form-submit');
    btn.textContent = 'Sending...';
    btn.disabled = true;
  });
}

/* ─── Discount ─── */
function applyDiscount() {
  var input = document.getElementById('discount-code');
  if (!input) return;
  var code = input.value.trim().toUpperCase();
  var msg = document.getElementById('discount-msg');
  if (!code) return;
  if (msg) { msg.textContent = 'Applying...'; msg.style.color=window.getComputedStyle(document.documentElement).getPropertyValue('--coral'); }
  fetch('/cart/update.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body: JSON.stringify({})
  }).then(function(){
    if (msg) {
      msg.textContent = code==='PEEK10' ? '10% discount applied!' : 'Code applied!';
      msg.style.color='var(--green,#06D6A0)';
    }
  }).catch(function(){
    if (msg) { msg.textContent = 'Invalid code'; msg.style.color='red'; }
  });
}
window.applyDiscount = applyDiscount;

/* ─── Checkout ─── */
function goCheckout() {
  window.location.href = '/checkout';
}
window.goCheckout = goCheckout;

/* ─── Add CSS spin animation ─── */
var spinStyle = document.createElement('style');
spinStyle.textContent = '@keyframes spin{to{transform:rotate(360deg)}}';
document.head.appendChild(spinStyle);

/* ─── Init ─── */
document.addEventListener('DOMContentLoaded', function(){
  initNavbar();
  initMobileMenu();
  initCountdown();
  initTicker();
  initStickyBar();
  initExitPopup();
  initScrollAnimations();
  initCartPage();
  initProductPage();
  initStickyCart();
  initFAQ();
  initShopFilter();
  initContactForm();
  initCartDrawer();
  initSearch();
  fetchCart();

  document.querySelectorAll('.currency-opt').forEach(function(el){
    el.addEventListener('click', function(){ switchCurrency(el.dataset.cur); });
  });
  document.querySelectorAll('.market-flag-btn').forEach(function(btn){
    btn.addEventListener('click', function(){ setMarket(btn.dataset.market); });
  });
  document.querySelectorAll('.lang-btn').forEach(function(btn){
    btn.addEventListener('click', function(){ setLanguage(btn.dataset.lang); });
  });

  document.querySelectorAll('.btn-cart[data-variant]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var vid = parseInt(this.dataset.variant);
      var imgSrc = this.closest('.product-card') ?
        (this.closest('.product-card').querySelector('img')||{src:''}).src : '';
      var name = this.closest('.product-card') ?
        (this.closest('.product-card').querySelector('.pc-name')||{textContent:''}).textContent : '';
      addToCart(vid, 1, this, imgSrc, name);
    });
  });

  document.getElementById('cart-notification-view') &&
    document.getElementById('cart-notification-view').addEventListener('click', function(){
      window.location.href='/cart';
    });

  /* Restore saved market + currency across page navigation */
  var _savedMkt = (function(){ try { return localStorage.getItem('pk_market'); } catch(e){ return null; } })();
  var _savedCur = (function(){ try { return localStorage.getItem('pk_currency'); } catch(e){ return null; } })();
  if (_savedMkt && _savedMkt !== 'CA') {
    MARKET = _savedMkt;
    document.querySelectorAll('.market-flag-btn').forEach(function(b){
      b.classList.toggle('active', b.dataset.market === _savedMkt);
    });
  }
  if (_savedCur && _savedCur !== 'CAD') {
    switchCurrency(_savedCur);
  }

  /* Language: restore saved preference or auto-detect browser language */
  var _savedLang = (function(){ try { return localStorage.getItem('pk_lang'); } catch(e){ return null; } })();
  if (_savedLang) {
    setLanguage(_savedLang);
  } else {
    var _browserLang = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
    setLanguage(_browserLang.startsWith('fr') ? 'FR' : 'EN');
  }
});

})();
